export const FrontPanelIcon = ({ rotation = 180, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-back-panel-icon"
    {...props}
  >
    <g transform={`rotate(${rotation} 12 12)`}>
      {/* dashed square border */}
      <path d="M14 21h1" />
      <path d="M21 14v1" />
      <path d="M21 19a2 2 0 0 1-2 2" />
      <path d="M21 9v1" />
      <path d="M3 14v1" />
      <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2" strokeWidth="4" />
      <path d="M3 9v1" />
      <path d="M5 21a2 2 0 0 1-2-2" />
      <path d="M9 21h1" />

      {/* up arrow */}
      <path d="m16 12-4-4-4 4" />
      <path d="M12 16V8" />
    </g>
  </svg>
);
